import {
  getHomeRailMenuLayout,
  homeRailColumnsForMode,
  homeRailMenuLabelTh,
  homeRailMenuMeta,
  homeRailOrderForMode,
  hydrateHomeRailMenuLayout,
  isHomeRailIdInMode,
  moveHomeRailMenuIdInOrder,
  replaceHomeRailMenuInOrder,
  normalizeHomeRailMenuLayout,
  paintGmRailPreviewDom,
  renderGmRailMenuBarMarkup,
  saveHomeRailMenuLayout,
  setHomeRailOrderForMode,
  type HomeRailEditMode,
  type HomeRailMenuId,
  type HomeRailMenuLayout,
} from "@/home/home-rail-menu-config";

export function renderGmHomeRailSectionHtml(): string {
  return `
    <section class="gm-section" id="gm-home-rail-section">
      <p class="hint">
        จัดเมนูซ้ายหน้า <a href="/home">/home</a> · แยกแบบย่อ/ขยาย · บันทึก IndexedDB · รีเฟรช /home หลังบันทึก
      </p>
      <form class="gm-rail-form" id="gm-home-rail-form">
        <div class="gm-rail-editor">
          <div class="gm-rail-editor-preview">
            <div class="gm-rail-editor-toolbar">
              <div class="gm-rail-mode-tabs" role="tablist" aria-label="โหมดตัวอย่าง">
                <button type="button" class="btn btn-ghost btn-sm gm-rail-mode-tab gm-rail-mode-tab--active" data-rail-mode="collapsed" role="tab" aria-selected="true">แบบย่อ</button>
                <button type="button" class="btn btn-ghost btn-sm gm-rail-mode-tab" data-rail-mode="expanded" role="tab" aria-selected="false">แบบขยาย</button>
              </div>
              <label class="field gm-rail-columns-field">
                <span class="field-label" id="gm-rail-columns-label">คอลัมน์ (แบบย่อ)</span>
                <select class="input" id="gm-rail-columns" name="columns">
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                </select>
              </label>
              <p class="hint gm-rail-editor-hint">คลิกกริดหรือแถบล่างเพื่อเพิ่ม · ถังขยะเอาออก · ลากทับเมนูเพื่อสลับ/แทนที่ · ○/◉ ปิดแสดงทั้งเกม</p>
            </div>
            <div class="gm-rail-preview-stage" id="gm-rail-preview-host" aria-label="ตัวอย่างเมนูบ้าน"></div>
            <div id="gm-rail-menu-bar-host"></div>
          </div>
          <aside class="gm-rail-inspector" id="gm-rail-inspector" aria-label="ตั้งค่าปุ่มที่เลือก" hidden>
            <h3 class="gm-rail-inspector-title" id="gm-rail-inspector-title">—</h3>
            <p class="hint gm-rail-inspector-id" id="gm-rail-inspector-id"></p>
            <label class="field gm-rail-inspector-field">
              <span class="field-label">แสดงในเกม</span>
              <input type="checkbox" id="gm-rail-inspector-enabled" />
            </label>
            <label class="field gm-rail-inspector-field">
              <span class="field-label" id="gm-rail-inspector-in-mode-label">รวมในแบบย่อ</span>
              <input type="checkbox" id="gm-rail-inspector-in-mode" />
            </label>
            <label class="field gm-rail-inspector-field" id="gm-rail-inspector-full-wrap">
              <span class="field-label">เต็มแถว (แบบขยาย)</span>
              <input type="checkbox" id="gm-rail-inspector-full" />
            </label>
            <div class="gm-rail-inspector-order">
              <button type="button" class="btn btn-ghost btn-sm" id="gm-rail-inspector-up">← ก่อนหน้า</button>
              <button type="button" class="btn btn-ghost btn-sm" id="gm-rail-inspector-down">ถัดไป →</button>
            </div>
            <p class="hint" id="gm-rail-inspector-feature"></p>
          </aside>
        </div>
        <div class="gm-settings-actions">
          <button type="submit" class="btn btn-primary">บันทึกเมนูบ้าน</button>
          <button type="button" class="btn btn-ghost" id="gm-rail-reset">รีเซ็ตค่าเริ่มต้น</button>
        </div>
        <p class="hint" id="gm-rail-status" role="status"></p>
      </form>
    </section>
  `;
}

function paintInspector(
  root: HTMLElement,
  layout: HomeRailMenuLayout,
  mode: HomeRailEditMode,
  selectedId: HomeRailMenuId | null,
): void {
  const panel = root.querySelector<HTMLElement>("#gm-rail-inspector");
  const fullWrap = root.querySelector<HTMLElement>("#gm-rail-inspector-full-wrap");
  if (!panel) return;
  if (fullWrap) fullWrap.hidden = mode !== "expanded";
  const inModeLabel = root.querySelector("#gm-rail-inspector-in-mode-label");
  if (inModeLabel) {
    inModeLabel.textContent = mode === "collapsed" ? "รวมในแบบย่อ" : "รวมในแบบขยาย";
  }
  if (!selectedId || !layout.items[selectedId]) {
    panel.hidden = true;
    return;
  }
  panel.hidden = false;
  const item = layout.items[selectedId];
  const meta = homeRailMenuMeta(selectedId);
  const title = root.querySelector("#gm-rail-inspector-title");
  const idEl = root.querySelector("#gm-rail-inspector-id");
  if (title) title.textContent = homeRailMenuLabelTh(selectedId);
  if (idEl) idEl.textContent = selectedId;
  const enabled = root.querySelector<HTMLInputElement>("#gm-rail-inspector-enabled");
  const inMode = root.querySelector<HTMLInputElement>("#gm-rail-inspector-in-mode");
  const full = root.querySelector<HTMLInputElement>("#gm-rail-inspector-full");
  if (enabled) enabled.checked = item.enabled;
  if (inMode) inMode.checked = isHomeRailIdInMode(layout, selectedId, mode);
  if (full) full.checked = item.fullWidthExpanded;
  const feat = root.querySelector("#gm-rail-inspector-feature");
  if (feat) {
    feat.textContent = meta.feature
      ? `ในเกมจริงต้องเปิด ${meta.feature}`
      : "ใช้ได้กับผู้เล่นทุกคน";
  }
}

function syncEditor(
  root: HTMLElement,
  layout: HomeRailMenuLayout,
  mode: HomeRailEditMode,
  selectedId: HomeRailMenuId | null,
): void {
  const select = root.querySelector<HTMLSelectElement>("#gm-rail-columns");
  if (select) select.value = String(homeRailColumnsForMode(layout, mode));
  const columnsLabel = root.querySelector("#gm-rail-columns-label");
  if (columnsLabel) {
    columnsLabel.textContent =
      mode === "collapsed" ? "คอลัมน์ (แบบย่อ)" : "คอลัมน์ (แบบขยาย)";
  }
  for (const tab of root.querySelectorAll<HTMLButtonElement>(".gm-rail-mode-tab")) {
    const active = tab.dataset.railMode === mode;
    tab.classList.toggle("gm-rail-mode-tab--active", active);
    tab.setAttribute("aria-selected", active ? "true" : "false");
  }
  const host = root.querySelector<HTMLElement>("#gm-rail-preview-host");
  if (host) paintGmRailPreviewDom(host, layout, mode, selectedId);
  const barHost = root.querySelector<HTMLElement>("#gm-rail-menu-bar-host");
  if (barHost) barHost.innerHTML = renderGmRailMenuBarMarkup(layout, mode, selectedId);
  paintInspector(root, layout, mode, selectedId);
}

function toggleIdInMode(
  layout: HomeRailMenuLayout,
  mode: HomeRailEditMode,
  id: HomeRailMenuId,
  include: boolean,
): HomeRailMenuLayout {
  const order = [...homeRailOrderForMode(layout, mode)];
  if (include) {
    if (!order.includes(id)) order.push(id);
  } else {
    const idx = order.indexOf(id);
    if (idx >= 0) order.splice(idx, 1);
  }
  return setHomeRailOrderForMode(layout, mode, order);
}

export async function prepareGmHomeRailSection(): Promise<void> {
  await hydrateHomeRailMenuLayout();
}

export function bindGmHomeRailSection(root: HTMLElement): () => void {
  const form = root.querySelector<HTMLFormElement>("#gm-home-rail-form");
  const status = root.querySelector<HTMLElement>("#gm-rail-status");
  const setStatus = (msg: string) => {
    if (status) status.textContent = msg;
  };

  let working = getHomeRailMenuLayout();
  let editMode: HomeRailEditMode = "collapsed";
  let selectedId: HomeRailMenuId | null = null;
  let dragId: HomeRailMenuId | null = null;
  let dropTargetEl: HTMLElement | null = null;

  const clearDropTarget = () => {
    if (!dropTargetEl) return;
    dropTargetEl.classList.remove(
      "gm-rail-preview-slot--drop-target",
      "gm-rail-bar-chip--drop-target",
      "gm-rail-preview-drop-target",
    );
    dropTargetEl = null;
  };

  const refresh = () => {
    syncEditor(root, working, editMode, selectedId);
  };

  refresh();

  const orderForEdit = () => homeRailOrderForMode(working, editMode);

  const applyOrder = (order: HomeRailMenuId[]) => {
    working = setHomeRailOrderForMode(working, editMode, order);
    refresh();
  };

  const moveSelected = (dir: -1 | 1) => {
    if (!selectedId) return;
    const order = [...orderForEdit()];
    const idx = order.indexOf(selectedId);
    if (idx < 0) return;
    const next = idx + dir;
    if (next < 0 || next >= order.length) return;
    const swap = order[next];
    order[idx] = swap;
    order[next] = selectedId;
    applyOrder(order);
  };

  const onModeTab = (event: Event) => {
    const btn = (event.target as HTMLElement).closest<HTMLButtonElement>(".gm-rail-mode-tab");
    const mode = btn?.dataset.railMode as HomeRailEditMode | undefined;
    if (!mode) return;
    editMode = mode;
    refresh();
  };

  const onPreviewClick = (event: Event) => {
    const target = event.target as HTMLElement;
    const removeBtn = target.closest<HTMLElement>("[data-rail-remove]");
    if (removeBtn?.dataset.railRemove) {
      event.preventDefault();
      event.stopPropagation();
      const id = removeBtn.dataset.railRemove as HomeRailMenuId;
      working = toggleIdInMode(working, editMode, id, false);
      if (selectedId === id) selectedId = null;
      refresh();
      return;
    }
    const cell = target.closest<HTMLElement>(".gm-rail-preview-cell");
    if (!cell?.dataset.railId) return;
    selectedId = cell.dataset.railId as HomeRailMenuId;
    refresh();
  };

  const onBarClick = (event: Event) => {
    const target = event.target as HTMLElement;
    const eye = target.closest<HTMLElement>("[data-bar-toggle-enabled]");
    if (eye?.dataset.barToggleEnabled) {
      event.stopPropagation();
      const id = eye.dataset.barToggleEnabled as HomeRailMenuId;
      const enabled = !working.items[id].enabled;
      working = {
        ...working,
        items: { ...working.items, [id]: { ...working.items[id], enabled } },
      };
      if (!enabled && selectedId === id) selectedId = null;
      if (enabled) {
        working = toggleIdInMode(working, editMode, id, true);
      } else {
        working = toggleIdInMode(working, "collapsed", id, false);
        working = toggleIdInMode(working, "expanded", id, false);
      }
      refresh();
      return;
    }
    const chip = target.closest<HTMLElement>(".gm-rail-bar-chip");
    const id = chip?.dataset.barId as HomeRailMenuId | undefined;
    if (!id) return;
    selectedId = id;
    if (!working.items[id].enabled) {
      working = {
        ...working,
        items: { ...working.items, [id]: { ...working.items[id], enabled: true } },
      };
      working = toggleIdInMode(working, editMode, id, true);
    } else {
      const inMode = isHomeRailIdInMode(working, id, editMode);
      working = toggleIdInMode(working, editMode, id, !inMode);
    }
    refresh();
  };

  const onDragStart = (event: Event) => {
    const dragEvent = event as DragEvent;
    if (
      (dragEvent.target as HTMLElement).closest("[data-rail-remove], [data-bar-toggle-enabled]")
    ) {
      dragEvent.preventDefault();
      return;
    }
    const el = (dragEvent.target as HTMLElement).closest<HTMLElement>(
      ".gm-rail-preview-cell, .gm-rail-bar-chip",
    );
    const id = (el?.dataset.railId ?? el?.dataset.barId) as HomeRailMenuId | undefined;
    if (!id || !working.items[id]?.enabled) return;
    const fromGrid = Boolean(el?.classList.contains("gm-rail-preview-cell"));
    if (fromGrid && !isHomeRailIdInMode(working, id, editMode)) return;
    dragId = id;
    if (dragEvent.dataTransfer) {
      dragEvent.dataTransfer.effectAllowed = "move";
      dragEvent.dataTransfer.setData("text/plain", id);
    }
  };

  const addDraggedToMode = () => {
    if (!dragId || isHomeRailIdInMode(working, dragId, editMode)) return;
    working = toggleIdInMode(working, editMode, dragId, true);
    refresh();
  };

  const resolveDropHighlight = (target: HTMLElement): HTMLElement | null => {
    const slot = target.closest<HTMLElement>(".gm-rail-preview-slot");
    const chip = target.closest<HTMLElement>(".gm-rail-bar-chip");
    if (slot || chip) return slot ?? chip;
    const empty = target.closest<HTMLElement>(".gm-rail-preview-drop-empty");
    if (empty) return empty;
    if (target.closest("#gm-rail-preview-frame, .gm-rail-preview-stage, #gm-rail-preview-host")) {
      return target.closest<HTMLElement>("#gm-rail-preview-frame");
    }
    return null;
  };

  const onDragOver = (event: Event) => {
    if (!dragId) return;
    event.preventDefault();
    const dragEvent = event as DragEvent;
    if (dragEvent.dataTransfer) dragEvent.dataTransfer.dropEffect = "move";
    const next = resolveDropHighlight(event.target as HTMLElement);
    if (next === dropTargetEl) return;
    clearDropTarget();
    if (!next) return;
    dropTargetEl = next;
    if (next.classList.contains("gm-rail-bar-chip")) {
      next.classList.add("gm-rail-bar-chip--drop-target");
    } else if (next.classList.contains("gm-rail-preview-slot")) {
      next.classList.add("gm-rail-preview-slot--drop-target");
    } else {
      next.classList.add("gm-rail-preview-drop-target");
    }
  };

  const onDrop = (event: Event) => {
    event.preventDefault();
    const target = event.target as HTMLElement;
    const el = target.closest<HTMLElement>(
      ".gm-rail-preview-slot, .gm-rail-preview-cell, .gm-rail-bar-chip",
    );
    const targetId = (el?.dataset.railId ?? el?.dataset.barId) as HomeRailMenuId | undefined;
    const onPreview = Boolean(
      target.closest(
        "#gm-rail-preview-frame, .gm-rail-preview-drop-empty, .gm-rail-preview-stage, #gm-rail-preview-host",
      ),
    );

    if (!dragId) {
      clearDropTarget();
      return;
    }

    if (targetId && dragId !== targetId) {
      const order = orderForEdit();
      const dragIdx = order.indexOf(dragId);
      const targetIdx = order.indexOf(targetId);
      if (dragIdx < 0 && targetIdx < 0) {
        addDraggedToMode();
      } else if (dragIdx < 0 && targetIdx >= 0) {
        applyOrder(moveHomeRailMenuIdInOrder(order, dragId, targetId));
      } else {
        applyOrder(replaceHomeRailMenuInOrder(order, dragId, targetId));
      }
      selectedId = dragId;
    } else if (onPreview) {
      addDraggedToMode();
      selectedId = dragId;
    }

    dragId = null;
    clearDropTarget();
  };

  const onDragEnd = () => {
    dragId = null;
    clearDropTarget();
  };

  const onInspectorChange = () => {
    if (!selectedId) return;
    const enabled = root.querySelector<HTMLInputElement>("#gm-rail-inspector-enabled");
    const inMode = root.querySelector<HTMLInputElement>("#gm-rail-inspector-in-mode");
    const full = root.querySelector<HTMLInputElement>("#gm-rail-inspector-full");
    const nextEnabled = enabled?.checked ?? true;
    working = {
      ...working,
      items: {
        ...working.items,
        [selectedId]: {
          ...working.items[selectedId],
          enabled: nextEnabled,
          fullWidthExpanded: full?.checked ?? working.items[selectedId].fullWidthExpanded,
        },
      },
    };
    if (!nextEnabled) {
      working = toggleIdInMode(working, "collapsed", selectedId, false);
      working = toggleIdInMode(working, "expanded", selectedId, false);
      selectedId = null;
    } else {
      working = toggleIdInMode(working, editMode, selectedId, inMode?.checked ?? false);
    }
    refresh();
  };

  const onColumns = () => {
    const cols = Number(root.querySelector<HTMLSelectElement>("#gm-rail-columns")?.value ?? 1);
    working =
      editMode === "collapsed"
        ? { ...working, columnsCollapsed: cols }
        : { ...working, columnsExpanded: cols };
    refresh();
  };

  const onSubmit = (event: Event) => {
    event.preventDefault();
    const next = normalizeHomeRailMenuLayout(working);
    void saveHomeRailMenuLayout(next).then(() => {
      working = next;
      setStatus("บันทึกแล้ว — รีเฟรชหน้า /home");
    });
  };

  const onReset = () => {
    working = normalizeHomeRailMenuLayout(undefined);
    editMode = "collapsed";
    selectedId = null;
    refresh();
    void saveHomeRailMenuLayout(working).then(() => {
      setStatus("รีเซ็ตและบันทึกค่าเริ่มต้นแล้ว");
    });
  };

  const previewHost = root.querySelector("#gm-rail-preview-host");
  const barHost = root.querySelector("#gm-rail-menu-bar-host");
  const modeTabs = root.querySelector(".gm-rail-mode-tabs");

  previewHost?.addEventListener("click", onPreviewClick, true);
  previewHost?.addEventListener("dragstart", onDragStart);
  previewHost?.addEventListener("dragover", onDragOver);
  previewHost?.addEventListener("drop", onDrop);
  previewHost?.addEventListener("dragend", onDragEnd);

  barHost?.addEventListener("click", onBarClick);
  barHost?.addEventListener("dragstart", onDragStart);
  barHost?.addEventListener("dragover", onDragOver);
  barHost?.addEventListener("drop", onDrop);
  barHost?.addEventListener("dragend", onDragEnd);

  modeTabs?.addEventListener("click", onModeTab);
  root.querySelector("#gm-rail-columns")?.addEventListener("change", onColumns);
  root.querySelector("#gm-rail-inspector-enabled")?.addEventListener("change", onInspectorChange);
  root.querySelector("#gm-rail-inspector-in-mode")?.addEventListener("change", onInspectorChange);
  root.querySelector("#gm-rail-inspector-full")?.addEventListener("change", onInspectorChange);
  root.querySelector("#gm-rail-inspector-up")?.addEventListener("click", () => moveSelected(-1));
  root.querySelector("#gm-rail-inspector-down")?.addEventListener("click", () => moveSelected(1));

  form?.addEventListener("submit", onSubmit);
  root.querySelector("#gm-rail-reset")?.addEventListener("click", onReset);

  void hydrateHomeRailMenuLayout().then((layout) => {
    working = layout;
    refresh();
  });

  return () => {
    form?.removeEventListener("submit", onSubmit);
    root.querySelector("#gm-rail-reset")?.removeEventListener("click", onReset);
    previewHost?.removeEventListener("click", onPreviewClick, true);
    barHost?.removeEventListener("click", onBarClick);
    modeTabs?.removeEventListener("click", onModeTab);
    root.querySelector("#gm-rail-columns")?.removeEventListener("change", onColumns);
  };
}
